import { render } from "./BankCard.vue?vue&type=template&id=04c4e4d2&scoped=true"
import script from "./BankCard.vue?vue&type=script&lang=js"
export * from "./BankCard.vue?vue&type=script&lang=js"

import "./BankCard.vue?vue&type=style&index=0&id=04c4e4d2&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c4e4d2"]])

export default __exports__